/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/least.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the minimum value from multiple columns. This is similar to `MV_MIN` except it is intended to run on multiple columns at once.
 *
 * @example
 * ROW a = 10, b = 20
 * | EVAL l = LEAST(a, b)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'least',
  signatures: [
    {
      params: [
        {
          name: 'first',
          type: 'boolean',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'first',
          type: 'boolean',
          optional: false,
        },
        {
          name: 'rest',
          type: 'boolean',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'first',
          type: 'date',
          optional: false,
        },
        {
          name: 'rest',
          type: 'date',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'first',
          type: 'date_nanos',
          optional: false,
        },
        {
          name: 'rest',
          type: 'date_nanos',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'first',
          type: 'double',
          optional: false,
        },
        {
          name: 'rest',
          type: 'double',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'first',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'first',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rest',
          type: 'integer',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'first',
          type: 'ip',
          optional: false,
        },
        {
          name: 'rest',
          type: 'ip',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'first',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'first',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'rest',
          type: 'keyword',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'first',
          type: 'long',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'first',
          type: 'long',
          optional: false,
        },
        {
          name: 'rest',
          type: 'long',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'first',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'first',
          type: 'text',
          optional: false,
        },
        {
          name: 'rest',
          type: 'text',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'first',
          type: 'version',
          optional: false,
        },
        {
          name: 'rest',
          type: 'version',
          optional: true,
        },
      ],
      variadic: true,
      returnType: 'version',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
